import { z } from "zod";

export const getLoadCarrierParamSchema = z.object({
	loadCarrierId: z.uuid(),
});

export type GetLoadCarrierParamSchema = z.infer<typeof getLoadCarrierParamSchema>;
